// Pure carrier-response summarisation for the China requests list (#1442).
// No React imports — these helpers are unit testable in isolation and reused
// by both the desktop row and mobile card.
//
// @aiPurpose Replace the legacy single-fill answers mini-bar with a
//   proportional two-colour segmented bar (answered=green, rejected=red,
//   pending=empty remainder). Data is already on the client via
//   `CarrierBid.state`; no backend round-trip.
// @aiInvariant Counts derive STRICTLY from `carrier.state` — never from
//   `bids[]`. `responded === answered + rejected`; pending is the leftover.

import type { CarrierBid } from './types.js';

export interface CarrierResponsesSummary {
  total: number;
  answered: number;
  rejected: number;
  pending: number;
  responded: number;
}

/**
 * Tally carrier states for the responses bar (FR-7, D2).
 *
 * @aiInvariant Computed only from `carrier.state`; `bids[]` is ignored.
 */
export function summarizeCarrierResponses(carriers: CarrierBid[]): CarrierResponsesSummary {
  let answered = 0;
  let rejected = 0;
  let pending = 0;
  for (const c of carriers) {
    if (c.state === 'answered') answered += 1;
    else if (c.state === 'rejected') rejected += 1;
    else if (c.state === 'pending') pending += 1;
  }
  return {
    total: carriers.length,
    answered,
    rejected,
    pending,
    responded: answered + rejected,
  };
}
